module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "label": "Limited to 10 characters"
    }
  }, [_c('b-taginput', {
    attrs: {
      "maxlength": "10",
      "value": ['Bulma', 'Vue', 'Buefy']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Limited to 5 tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "maxtags": "5",
      "value": ['One', 'Two', 'Three', 'Four']
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Limited to 10 characters and 5 tags"
    }
  }, [_c('b-taginput', {
    attrs: {
      "maxlength": "10",
      "maxtags": "5",
      "value": ['Red', 'Green', 'Blue', 'White']
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2cd8e23f"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/taginput/examples/ExLimit.vue
// module id = 1256
// module chunks = 7 177